import { Video, Target, Layers, CalendarClock } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { PageHeader } from "@/components/Section";
import Reveal from "@/components/Reveal";

const icons = [Video, Target, Layers, CalendarClock];
const COACH_IMG = "https://customer-assets.emergentagent.com/job_web-editor-45/artifacts/bbudb6mb_ChatGPT%20Image%2025.%20Juni%202026%2C%2002_17_00.png";

const Einzeltraining = () => {
  const { t, lang } = useLang();
  const e = t.einzel;
  return (
    <div data-testid="einzeltraining-page">
      <PageHeader kicker={e.kicker} title={e.title} intro={e.intro} />

      <section className="pb-24 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* GolfTimer Buchung */}
        <div data-testid="golftimer-section">
          {/* GolfTimer Embed */}
          <Reveal direction="up"
            id="golftimer-embed"
            data-testid="golftimer-embed"
            className="w-full border border-white/10 overflow-hidden bg-white"
          >
            <iframe
              title="GolfTimer Buchung"
              src="https://ssl.golftimer.de/?sys=A35&mobile=yes&ds=off"
              width="100%"
              height="800"
              frameBorder="0"
              className="w-full block"
              style={{ minHeight: "800px" }}
            />
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-16 md:mt-20">
          {e.features.map((f, i) => {
            const Icon = icons[i % icons.length];
            return (
              <Reveal key={f.t} direction={i % 2 === 0 ? "left" : "right"} delay={(i % 2) * 0.08}
                data-testid={`einzel-feature-${i}`}
                className="bg-[#0F0F0F] border border-white/10 p-8 hover:border-[#ff0033]/60 transition-colors group"
              >
                <Icon size={28} className="text-[#ff0033]" />
                <h3 className="font-heading text-2xl uppercase tracking-tight text-white mt-5 group-hover:text-[#ff0033] transition-colors">
                  {f.t}
                </h3>
                <p className="text-neutral-400 text-sm mt-3 leading-relaxed">{f.d}</p>
              </Reveal>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default Einzeltraining;
